import type { ActiveTools, ToolVariant } from '../types'

export function isToolActive<T extends string>(activeTools: ActiveTools<T>, card: ToolVariant<T>) {
  const cardIsActiveSelect = activeTools.select === card.toolId
  const cardIsActiveActivate = activeTools.activate.has(card.toolId)
  const childOfCardIsActive =
    card.type === 'container' &&
    card.children.some(child => {
      const childIsActiveSelect = activeTools.select === child.toolId
      const childIsActiveActivate = activeTools.activate.has(child.toolId)

      return childIsActiveActivate || childIsActiveSelect
    })

  return cardIsActiveSelect || cardIsActiveActivate || childOfCardIsActive
}
